<template>
	<div class="container">
		<CFullEmpty v-if="emptyData" emptyText="暂无数据" />
		<CTabs v-if="showHeaderTabs" v-model="activeTab" :ellipsis="false" :option="getTabOption" />
		<div class="act-content">
			<keep-alive>
				<component :is="currentComponent" />
			</keep-alive>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from '@/utils/vue-api';
import CTabs from '@/view/enterprise/components/c-tabs.vue';
import RoadshowIndex from './RoadshowIndex.vue';
import OfflineIndex from './OfflineIndex.vue';
import ResearchIndex from './ResearchIndex.vue';
import AllIndex from './AllIndex.vue';
import { useInvestmentActivityTabs } from './useInvestmentActivityTabs';
import i18n, { EN } from '@/assets/js/i18n';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import { useCommonData } from '@rebuild/hooks/useCommonData';

const { isCardMTmpl } = useCommonData();

const route = useRoute();
const isEn = computed(() => i18n.locale === EN);

// 使用下标作为选中值，便于与 CTabs 对齐
const activeTab = ref(0);
const tabOption = ref([]); // [{ label, value }]

const getTabOption = computed(() => tabOption.value.map(v => v.label));
const showHeaderTabs = computed(() => {
	if (isCardMTmpl.value) return true;
	return !isEn.value && tabOption.value.length > 1;
});

const { getAvailableTabs } = useInvestmentActivityTabs();
const emptyData = ref(false);

const refreshView = async () => {
	if (isEn.value && !isCardMTmpl.value) {
		return;
	}

	const validOptions = await getAvailableTabs();
	if (!validOptions.length) {
		emptyData.value = true;
		return;
	}

	tabOption.value = validOptions;

	// Tab默认选中
	const routeActive = route.query.active;
	const routeIdx = tabOption.value.findIndex(opt => opt.value === routeActive);
	activeTab.value = routeIdx !== -1 ? routeIdx : 0;
};
onMounted(() => {
	refreshView();
});

const COMP_MAPS = {
	investment_activity_all: AllIndex,
	roadshow: RoadshowIndex,
	offline: OfflineIndex,
	research: ResearchIndex
};
const currentComponent = computed(() => {
	if (isEn.value && !isCardMTmpl.value) return AllIndex;
	const idx = activeTab.value;
	const moduleId = tabOption.value[idx]?.value;
	return COMP_MAPS[moduleId] || null;
});
</script>

<style lang="less" scoped>
.container {
	height: 100%;
	display: flex;
	flex-direction: column;

	.act-content {
		flex: 1;
		height: 0;
		position: relative;
		z-index: 1;
	}
}
</style>
